import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PlatformProvider } from './contexts/PlatformContext';
import { AppShell } from './components/layout/AppShell';
import { Dashboard } from './pages/Dashboard';
import { Applications } from './pages/Applications';
import { ApplicationReview } from './pages/ApplicationReview';
import { PortfolioBoard } from './pages/PortfolioBoard';
import { LifecycleWorkspace } from './pages/LifecycleWorkspace';
import { AiHub } from './pages/AiHub';
import { Analytics } from './pages/Analytics';
import { Reports } from './pages/Reports';
import { Outreach } from './pages/Outreach';
import { Registry } from './pages/Registry';
import { Toaster } from './components/ui/Sonner';
export function App() {
  return <PlatformProvider data-id="element-0" data-mp="2wi5mthatqlos">
      <BrowserRouter data-id="element-1" data-mp="28u5ysp4wd9dw">
        <Routes data-id="element-2" data-mp="28te198rqp1kz">
          <Route element={<AppShell data-id="element-4" data-mp="28sl511qepuh3" />} data-id="element-3" data-mp="28t4jg8gum0qd">
            <Route path="/" element={<Dashboard data-id="element-6" data-mp="23vupcfiil0w7" />} data-id="element-5" data-mp="23vcjqs9ypabm" />
            <Route path="/applications" element={<Applications data-id="element-8" data-mp="23ti7e2craqj5" />} data-id="element-7" data-mp="23ujl6el5pr4k" />
            <Route path="/applications/:id" element={<ApplicationReview data-id="element-10" data-mp="3ijfthv617oci" />} data-id="element-9" data-mp="3ikh9me1wn113" />
            <Route path="/lifecycle" element={<PortfolioBoard data-id="element-12" data-mp="3mkhlps1j704z" />} data-id="element-11" data-mp="3mlj98vzqhf3l" />
            <Route path="/lifecycle/:id" element={<LifecycleWorkspace data-id="element-14" data-mp="3rcj6k2crlz6m" />} data-id="element-13" data-mp="3mjq3diwy2ywn" />
            <Route path="/intelligence" element={<AiHub data-id="element-16" data-mp="3recc1ebn6dd1" />} data-id="element-15" data-mp="3rdkisa5iorpx" />
            <Route path="/analytics" element={<Analytics data-id="element-18" data-mp="4wylxj0jajy" />} data-id="element-17" data-mp="5orh0l86u6j" />
            <Route path="/reports" element={<Reports data-id="element-20" data-mp="2zld0z6e9z99y" />} data-id="element-19" data-mp="56qxrrj5tst" />
            <Route path="/outreach" element={<Outreach data-id="element-22" data-mp="2zmwj72jhrued" />} data-id="element-21" data-mp="2zlv32jnmchps" />
            <Route path="/registry" element={<Registry data-id="element-24" data-mp="33lwzadal4ixo" />} data-id="element-23" data-mp="33mou3lwcycmw" />
            <Route path="*" element={<Dashboard data-id="element-26" data-mp="33orla998ybt7" />} data-id="element-25" data-mp="33n6yj5t6bx5w" />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton data-id="element-27" data-mp="38kgkgbhctqoz" />
    </PlatformProvider>;
}